import RelationshipMetadata from "../../RelationshipMetadata";

class AccountUserAccountUserPositionRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "AccountUserAccountUserPositionRelationshipMetadata";
        this.parentEnterpriseComponent = "AccountUser";
        this.childEnterpriseComponent = "AccountUserPosition";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "PositionUSID";
    }
}

export default AccountUserAccountUserPositionRelationshipMetadata;